import { createAction } from "@reduxjs/toolkit";
import { TCNN } from "ui/tcnn/types";

export const addBottomSheet = createAction<TCNN>(
  "lwc/bottomSheet/addBottomSheet"
);
